// Static site content + business details for NFT

export const BUSINESS = {
  name: 'National Forklift Training Ltd',
  shortName: 'NFT',
  tagline: 'Serious Training — Safe Operators — No Compromise',
  established: 1990,
  rating: 4.9,
  reviewCount: 112,
  phone: '(09) 271 6565',
  phoneHref: 'tel:+6492716565',
  fax: '(09) 271 6666',
  mobile: '(0275) 824 207',
  mobileHref: 'tel:+64275824207',
  email: 'admin@nationalforklifttraining.nz',
  emailHref: 'mailto:admin@nationalforklifttraining.nz',
  address: {
    line1: 'Unit 9, 1 Highbrook Drive',
    line2: 'East Tamaki Industrial',
    city: 'Auckland',
    postcode: '2013',
    country: 'New Zealand',
  },
  hours: 'Mon–Fri, 8:00am – 4:00pm',
  busRoutes: ['#575', '#566', '#561'],
  mapEmbed:
    'https://www.google.com/maps?q=1+Highbrook+Drive,+East+Tamaki,+Auckland+2013,+New+Zealand&output=embed',
};

export const TRUST_BADGES = [
  { label: '25+', suffix: 'Years', text: 'Operating since 1990' },
  { label: '100%', suffix: 'NZ Owned', text: 'Kiwi family business' },
  { label: '4.9★', suffix: '112 Reviews', text: 'Google verified' },
  { label: 'WorkSafeNZ', suffix: 'Approved', text: 'Audited by Competenz' },
];

export const COURSES = [
  {
    slug: 'standard',
    title: 'Standard / Renewal Training',
    short: 'For experienced operators and renewals — full WorkSafeNZ certification.',
    duration: '~5 hours',
    audience: 'Experienced operators',
    image: '/generated/course-standard.png',
    icon: 'forklift',
  },
  {
    slug: 'beginner',
    title: 'Beginner Course',
    short: '2-day programme for those with little or no forklift experience.',
    duration: '2 days',
    audience: 'New operators',
    image: '/generated/course-beginner.png',
    icon: 'rocket',
  },
  {
    slug: 'beginner',
    title: 'Reach Truck Beginner',
    short: 'Specialised reach truck training for narrow-aisle warehouse work.',
    duration: '2 days',
    audience: 'New operators',
    image: '/generated/course-reach-truck.png',
    icon: 'reach',
  },
  {
    slug: 'standard',
    title: 'Individual Assessments',
    short: 'One-on-one competency assessment, tailored to your equipment.',
    duration: '~2 hours',
    audience: 'Existing operators',
    image: '/generated/course-standard.png',
    icon: 'badge',
  },
  {
    slug: 'f-endorsement',
    title: '"F" Endorsement',
    short: 'Licence to operate registered forklifts on public roadways.',
    duration: '+1 hour add-on',
    audience: 'Class 1 licence holders',
    image: '/generated/course-reach-truck.png',
    icon: 'license',
  },
  {
    slug: 'nzqa',
    title: 'NZQA Unit Standards',
    short: 'Gain formal NZQA credits — Unit Standards 10851, 10852, 18496.',
    duration: 'Add-on assessment',
    audience: 'Career operators',
    image: '/generated/certification.png',
    icon: 'certificate',
  },
];

export const ADDITIONAL_SERVICES = [
  'Independent Accident Investigations',
  'On-site Risk Management',
  'On-site Safety Surveys',
  'Team Building Forklift Competitions',
  'Safety Awareness Workshops',
  'Warehouse Layout Consulting',
];

export const COURSE_OPTIONS = [
  { value: 'standard', label: 'Standard / Renewal Training' },
  { value: 'beginner-counterbalance', label: 'Beginner — Counterbalance' },
  { value: 'beginner-reach', label: 'Beginner — Reach Truck' },
  { value: 'individual-assessment', label: 'Individual Assessment' },
  { value: 'f-endorsement', label: '"F" Endorsement' },
  { value: 'nzqa', label: 'NZQA Unit Standard Assessment' },
  { value: 'safety-workshop', label: 'Safety Awareness Workshop' },
  { value: 'consulting', label: 'Consulting / Audit' },
  { value: 'other', label: 'Other / Not sure' },
];
